/**
 * Explicit AI-processing consent (OpenAI on CV content).
 * Reused after the user already ticked it on ATS, so Quick Edit
 * does not ask again in the same browser.
 */

export const AI_CONSENT_KEY = 'clarcv_ai_consent';

const isBrowser = () => typeof window !== 'undefined';

/**
 * True when this browser already recorded an AI-processing tick.
 *
 * @returns {boolean}
 */
export const hasAiConsent = () => {
  if (!isBrowser()) return false;
  try {
    return window.localStorage.getItem(AI_CONSENT_KEY) === '1';
  } catch (err) {
    return false;
  }
};

/**
 * Persist that the user agreed to send CV content to OpenAI.
 */
export const rememberAiConsent = () => {
  if (!isBrowser()) return;
  try {
    window.localStorage.setItem(AI_CONSENT_KEY, '1');
  } catch (err) {
    /* private mode / blocked storage */
  }
};
